import React, { useEffect, useState } from "react";
import axios from "axios";
import { Loader2, Landmark, FileDown } from "lucide-react";
import { API, btnGhost, Empty } from "./shared";
import { CashoutBadge, downloadReceipt } from "../AdminCashouts";

const BANKS = { BG: "Banco General", Banesco: "Banesco", Banistmo: "Banistmo" };
const money = (v) => `$${Number(v || 0).toLocaleString("en-US", { minimumFractionDigits: 2, maximumFractionDigits: 2 })}`;

const ClientCashouts = ({ appId, headers }) => {
  const [rows, setRows] = useState(null);
  const [balance, setBalance] = useState(null);

  useEffect(() => {
    Promise.all([axios.get(`${API}/crm/cashouts`, { headers }), axios.get(`${API}/crm/cashouts/balance/${appId}`, { headers })])
      .then(([a, b]) => { setRows(a.data.filter((c) => c.app_id === appId)); setBalance(b.data); })
      .catch(() => { setRows([]); });
  }, [appId, headers]);

  if (!rows) return <div className="py-10 flex justify-center"><Loader2 className="animate-spin text-[#0fb013]" /></div>;

  return (
    <div data-testid="crm-cashouts" className="space-y-4">
      {balance && (
        <div className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-6 gap-2">
          {[["Ventas", balance.ventas], ["Reembolsos", balance.reembolsos], ["Comisiones", balance.comisiones], ["Cashouts aprobados", balance.cashouts_aprobados], ["Cashouts pendientes", balance.cashouts_pendientes], ["Disponible", balance.disponible]].map(([k, v], i) => (
            <div key={k} data-testid={i === 5 ? "crm-balance-disponible" : undefined} className={`rounded-xl px-3.5 py-2.5 border ${i === 5 ? "bg-black text-white border-black" : "bg-[#fafcf9] border-black/[0.06]"}`}>
              <p className={`text-[10px] font-bold uppercase tracking-wider ${i === 5 ? "text-white/70" : "text-black/40"}`}>{k}</p>
              <p className={`text-[15px] font-extrabold ${i === 5 && v < 0 ? "text-[#ff8a6b]" : ""}`}>{money(v)}</p>
            </div>
          ))}
        </div>
      )}
      {rows.length === 0 ? <Empty icon={Landmark} text="Este cliente no tiene solicitudes de cashout" /> : (
        <div className="bg-white border border-black/[0.06] rounded-2xl overflow-x-auto">
          <table className="w-full text-[12px]">
            <thead><tr className="text-left text-[10px] uppercase tracking-wider text-black/45 border-b border-black/[0.06]">{["Fecha", "Tienda", "Beneficiario", "Banco · Cuenta", "ID TRX", "Monto", "Estado", "Recibo"].map((h) => <th key={h} className="px-4 py-3 font-bold">{h}</th>)}</tr></thead>
            <tbody>
              {rows.map((c) => (
                <tr key={c.id} data-testid={`crm-cashout-${c.id}`} className="border-b border-black/[0.04]">
                  <td className="px-4 py-3 font-semibold whitespace-nowrap">{c.date}</td>
                  <td className="px-4 py-3">{c.store}</td>
                  <td className="px-4 py-3">{c.beneficiary}</td>
                  <td className="px-4 py-3 whitespace-nowrap">{BANKS[c.bank]} · {c.account}</td>
                  <td className="px-4 py-3 font-mono text-[11px]">{c.trx_id}</td>
                  <td className="px-4 py-3 font-extrabold text-[13px]">{money(c.amount)}</td>
                  <td className="px-4 py-3"><CashoutBadge status={c.status} />{c.reject_reason && <p className="mt-1 text-[10px] text-black/50">{c.reject_reason}</p>}</td>
                  <td className="px-4 py-3">{c.status === "aprobado" && <button onClick={() => downloadReceipt(`${API}/crm/cashouts/${c.id}/receipt.pdf`, headers, `recibo_${c.receipt?.trx_number}.pdf`)} className={btnGhost}><FileDown size={12} /> {c.receipt?.trx_number}</button>}</td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      )}
    </div>
  );
};

export default ClientCashouts;
